import React from "react";
import { MenuItem } from "@shared/interfaces";
import { Logo } from "@shared/components/Logo";
import { User } from "@shared/models";
import { useLocation } from "react-router";

import { SidebarItems } from "../SidebarItems";
import { AvatarMenu } from "./AvatarMenu";

import "./index.scss";

export interface MainSidebarProps {
  user: User | null;
  items: MenuItem[];
}

const Sidebar = (props: MainSidebarProps) => {
  const { items, user } = props;

  const location = useLocation();

  return (
    <div className="main-sidebar">
      <div className="sidebar-logo">
        <Logo />
      </div>
      <SidebarItems items={items} currentPathname={location.pathname} />
      <div className="sidebar-logout-wrapper">
        <div className="sidebar-logout">
          <AvatarMenu user={user} />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
